import type { FC, ComponentProps } from 'react';
import type { FormInstance } from 'antd';

export enum EFormDrawerSize {
  LARGE = 'large',
  MIDDLE = 'middle',
  DEFAULT = 'default',
}

export type TFormDrawerGenericType = FC<Record<string, unknown>>;

export interface IFormDrawerBaseComponentProps<V> {
  form: FormInstance<V>;
  formId: string;
  onFinish: (values: V) => void;
}

export interface IFormDrawerProps<T extends TFormDrawerGenericType> {
  formComponent: T;
  formProps?: Omit<ComponentProps<T>, 'onFinish' | 'form' | 'formId'>;
  title: string;
  isOpen: boolean;

  formInstance?: FormInstance;
  isLoading?: boolean;
  size?: EFormDrawerSize;

  displayMaskClickConfirmation?: boolean;
  onFinish: (values: any) => Promise<void>;
  onClose: () => void;
  preventCloseOnFinish?: boolean;
}
